"use client";
import { DrupalNode } from "next-drupal";
import Link from "next/link";
import React from "react";
import { motion } from "framer-motion";

interface FindOutSectionProps {
  data: DrupalNode;
}

const FindOutSection: React.FC<FindOutSectionProps> = ({
  data = {} as DrupalNode,
}) => {
  const { title = "", field_button_text = "", field_link = "" } = data;
  return (
    <motion.div className="pt-[125px] pb-[100px] bg-mapGray relative mobileMax:py-14 overflow-hidden">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{
          duration: 0,
        }}
        className="remove-animation-fluctuation overflow-hidden mini-container relative z-[1]"
      >
        <h2 className="category-gradient mb-[50px] text-numans font-normal text-xlarge tracking-tighter text-clip text-center betweenMobileTab:text-[52px] mobileMax:text-[28px]">
          {title}
        </h2>
        <div className="flex items-center justify-center">
          <Link
            href={field_link}
            target="_blank"
            className="flex items-center justify-center min-w-[220px] --font-poppins bg-[linear-gradient(to_right,#316FA8,#003350)] !text-white text-medium min-h-[55px] rounded-lg  hover:!underline !no-underline mobileMax:min-w-full mobileMax:text-medium mobileMax:mb-3"
          >
            {field_button_text}
          </Link>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default FindOutSection;
